export const PlanTemplateIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
      <path
        d="M10.5 14.5H7.5V11.5"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5 11.5L7.5 14.5"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 14.5H18.5C19.8807 14.5 21 13.3807 21 12V4C21 2.61929 19.8807 1.5 18.5 1.5L7.5 1.5C6.11929 1.5 5 2.61929 5 4V6.5"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="1"
        y="6.5"
        width="16"
        height="13"
        rx="2.5"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
